import { ReviewItem } from '@/components/Reviews';
import type { TFunction } from 'i18next';

export const getCustomerReviews = (t: TFunction): ReviewItem[] => {
  return t('reviews.customers', { returnObjects: true }) as ReviewItem[];
};

// Legacy export for backward compatibility
export const customerReviews: ReviewItem[] = [
  {
    id: '1',
    customerName: 'Ashikin Rahman',
    city: 'Kuala Lumpur',
    service: 'Servis Pembersihan Fabrik',
    content: 'Terbaik 👍🏻👍🏻👍🏻 terima kasih team TRhine untuk servis yang cepat dan mantap. Moga diluaskan rezeki lagi dan lagi! 😊',
    rating: 5,
    platform: "facebook"
  },
  {
    id: '2',
    customerName: 'Hasliza Abu Hassim',
    city: 'Puncak Perdana',
    service: 'Servis Pembasmian Kuman',
    content: 'Terima kasih banyak atas bantuan sanitasi ... terbaik servis! 👍🏻🌹',
    rating: 5,
    platform: "whatsapp"
  },
  {
    id: '3',
    customerName: 'Muhammad Zayn',
    city: 'Klang',
    service: 'Servis Pembersihan Fabrik',
    content: 'staff kerja sangat kemas dan teliti👍👍, semoga business terus maju',
    rating: 5,
    platform: "facebook"
  },
  {
    id: '4',
    customerName: 'Shadila',
    city: 'Shah Alam',
    service: 'Servis Polish Kereta',
    content: 'Tq atas servis yang terbaik. Puas hati sangat sangat! 👍🏻😊',
    rating: 5,
    platform: "whatsapp"
  },
  {
    id: '5',
    customerName: 'Azmi Aizat Hakimi',
    city: 'Puncak Alam',
    service: 'Servis Penghawa Dingin',
    content: 'team sangat beradab dan tepati waktu. Saya sangat suka dan puas hati dengan servis dari trhine🥰. Insyallah saya repeat lagi',
    rating: 5,
    platform: "whatsapp"
  }
];